<!--
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:23
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2024-03-29 17:02:50
 * @FilePath     : \gray-fabric-defect-management-frontend\src\layout\baseLayout\index.vue
 * @Description  : 这是描述
-->
<template>
  <a-layout has-sider class="baseLayout">
    <a-layout-sider :style="{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0, top: 0, bottom: 0 }"
      v-model:collapsed="collapsed" :trigger="null">
      <div class="logo">{{ $t(`login.menuTitle`) }}</div>
      <Menu />
    </a-layout-sider>
    <a-layout :style="{ marginLeft: collapsed ? '80px' : '200px', minHeight: '100vh' }">
      <a-layout-header class="baseLayoutHeader">
        <menu-unfold-outlined v-if="collapsed" class="trigger" @click="() => (collapsed = !collapsed)" />
        <menu-fold-outlined v-else class="trigger" @click="() => (collapsed = !collapsed)" />
        <NavBar />
      </a-layout-header>
      <a-layout-content :style="{
        margin: '24px 16px 12px', overflow: 'initial', background: '#fff', padding: '24px 24px 0',
        minHheight: '280px'
      }">
        <router-view></router-view>
      </a-layout-content>
      <!-- <a-layout-footer :style="{ textAlign: 'center' }">
      </a-layout-footer> -->
    </a-layout>
  </a-layout>
</template>

<script lang="ts" setup>
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons-vue'
import { onBeforeMount, ref } from 'vue'
import Menu from '../components/menu/index.vue'
import NavBar from '../components/navBar/index.vue'

import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()


import { loginStore } from '../../store/login'
const store = loginStore()
const selectedKeys = ref<string[]>(['1'])
const collapsed = ref<boolean>(false)

onBeforeMount(() => {
  store.getUserInfo({ callback: () => { } })
})
</script>

<style lang="less">
@import url('./index.less');
</style>
